import { Component, Input } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

/**
 * Hosts {@link DocumentPreviewComponent} outside of a second ngx-bootstrap modal so it does not
 * inherit the parent modal's {@link BsModalRef} (which would close the parent when preview closes).
 */
@Component({
  selector: "app-embedded-document-preview",
  template: `
    <div class="embedded-document-preview-shell">
      <app-document-preview
        [signedLink]="signedLink"
        [embedded]="true"
      ></app-document-preview>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        min-height: 0;
      }
      .embedded-document-preview-shell {
        height: calc(90vh - 140px);
        min-height: 520px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .embedded-document-preview-shell ::ng-deep .modal-body.modal-fixed-height {
        flex: 1;
        min-height: 0;
        max-height: none;
      }
    `,
  ],
  providers: [
    {
      provide: BsModalRef,
      useValue: {
        hide: () => {},
        setClass: () => {},
      } as BsModalRef,
    },
  ],
})
export class EmbeddedDocumentPreviewComponent {
  @Input() signedLink!: string;
}
